import { apiFetch } from "@/integrations/backend/client";

export type EnergyLevelChoiceValue = "supercharged" | "ready" | "tired" | "low" | "injured";

export type EnergyLevelChoiceResponse = {
  id: string;
  choice: string;
  selected_at: string | null;
};

export async function createEnergyLevelChoice(choice: EnergyLevelChoiceValue): Promise<EnergyLevelChoiceResponse> {
  const res = await apiFetch("/api/v1/energy-level-choice", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ choice }),
  });
  if (!res.ok) {
    throw new Error(`energy_level_choice_create_failed:${res.status}`);
  }
  return (await res.json()) as EnergyLevelChoiceResponse;
}
